import { NotificationSeverity } from '@/components/notifications/Notification';
import { useNotification } from '@/hooks';
import { ISector, PendingCounterApiResponse } from '../../models';

interface useSectorActionsProps {
  selectedSector: ISector | null;
  setSelectedSector: (sector: ISector) => void;
}

const useSectorActions = ({
  selectedSector,
  setSelectedSector,
}: useSectorActionsProps) => {
  const { showNotification } = useNotification();

  const onToggleLock = (sector: PendingCounterApiResponse) => {
    if (selectedSector?.id !== sector.sectorId) return;

    const willLock = !selectedSector?.isLocked;

    setSelectedSector({ ...selectedSector, isLocked: willLock });

    showNotification(
      willLock
        ? `Bloqueaste el sector ${sector.sectorName}`
        : `Desbloqueaste el sector ${sector.sectorName}`,
      NotificationSeverity.success,
      willLock ? 1500 : 1000
    );
  };

  const onSelectSector = (sector: PendingCounterApiResponse) => {
    const isAlreadySelected = selectedSector?.id === sector.sectorId;
    if (isAlreadySelected) return;

    if (selectedSector?.isLocked) {
      showNotification(
        'No puedes cambiar de sector, el sector ' +
          selectedSector?.name +
          ' esta bloqueado',
        NotificationSeverity.error,
        1500
      );
      return;
    }

    setSelectedSector({
      id: sector.sectorId,
      name: sector.sectorName,
      isLocked: selectedSector?.isLocked || false,
    });
    showNotification(
      'Cambiaste al sector ' + sector.sectorName,
      NotificationSeverity.success,
      800
    );
  };

  return {
    onToggleLock,
    onSelectSector,
  };
};

export default useSectorActions;
